import React from 'react';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { FormPageFieldComponentProps } from 'types/formPage';

import { withFormikFormControl } from '../FormikFormControl';
import {DateTimeField} from "./DateTime";

export const DateField = (props: FormPageFieldComponentProps) => {
  console.log('DATE', {props})
  return <DateTimeField {...props} time={false}/>
};

export const DateFormik = withFormikFormControl()(DateField);

export default DateFormik;
